<template>
  <div class="mainPage">
    <div class="header_banner">
      <img
        src="../img/harmonious2025/banner.png"
        alt="和合之美"
        class="banner_img"
      />
    </div>
    <div class="theme_intro">
      <div class="theme_intro_cn">
        <!-- <p>2025“和合之美”中央广播电视总台精品节目展播</p> -->
        “君子和而不同”，“天地合而万物生”。数千年来，中华文明与不同文明相遇相知、交融互鉴，共祈和平愿景、合书盛世华章。在此，我们邀您共赏《中国神话故事（精编版）》《良渚（精编版）》《中国式现代化之路（精编版）》《美美与共（精编版）》等中央广播电视总台出品的多语种精品节目，在感受中华文化的独特魅力、领略世界文明百花园的绚丽光彩中，跨越国界，倾听和平发展、命运与共的时代回响！

        <p>精彩节目，陆续上新，敬请期待！</p>
      </div>
      <div class="theme_intro_en">
        <p></p>
        For thousands of years, Chinese civilization and different civilizations
        have met and known each other, blended and learned from each other,
        co-praying for a vision of peace, and co-creating glorious chapters in
        prosperous eras. Here, we invite you to enjoy CCTV/CGTN’s multilingual
        premium programs, including
        <span class="xt"
          >Chinese Mythological Stories, Liangzhu, The Path to Modernization,
          Harmony in Diversity</span
        >. In experiencing the unique charm of Chinese culture and appreciating
        the splendid colors of the world's civilizations garden, we transcend
        national boundaries and listen to the echoes of the times that call for
        peaceful development and shared destiny!
        <p>
          More fantastic programs are coming up. Stay tuned!
        </p>
      </div>
      <div
        class="theme_intro_footer"
        ref="pcThemeIntro"
        :class="{ 'is-fixed': isPcThemeIntroFixed }"
      >
        <div class="theme_intro_footer_left">
          <div class="theme_intro_footer_title">
            <div class="theme_intro_footer_title_top">节目语种</div>
            <div class="theme_intro_footer_title_bottom">
              Language of the programs
            </div>
          </div>
        </div>
        <div class="col">
          <div class="theme_intro_footer_right">
            <div
              class="lang_tab"
              :class="{ active: activeLang === '中文' }"
              @click="switchLang('中文')"
            >
              中文
            </div>
            <div
              class="lang_tab"
              :class="{ active: activeLang === 'English' }"
              @click="switchLang('English')"
            >
              English
            </div>
            <div
              class="lang_tab"
              :class="{ active: activeLang === 'Русский' }"
              @click="switchLang('Русский')"
            >
              Русский
            </div>
            <div
              class="lang_tab"
              :class="{ active: activeLang === 'Казахский' }"
              @click="switchLang('Казахский')"
            >
              Казахский
            </div>
            <div
              class="lang_tab"
              :class="{ active: activeLang === 'Español' }"
              @click="switchLang('Español')"
            >
              Español
            </div>
            <div
              class="lang_tab"
              :class="{ active: activeLang === 'Português Brasileiro' }"
              @click="switchLang('Português Brasileiro')"
            >
              Português Brasileiro
            </div>
            <div
              class="lang_tab"
              :class="{ active: activeLang === 'Français' }"
              @click="switchLang('Français')"
            >
              Français
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="core_content">
      <div
        class="classBox"
        v-for="subject in subject_info"
        :key="subject.id"
        :ref="subject.id"
        :id="'lang-' + getSubjectLanguage(subject)"
        :data-lang="getSubjectLanguage(subject)"
      >
        <div class="classBox1" :id="'t' + subject.id">
          <div class="series_info">
            <div class="info_left">
              <div
                class="cloud_con"
                :style="{ backgroundImage: getCloudBackground(subject) }"
              >
                <div class="serise_icon_con">
                  <img
                    :src="subject.image_url"
                    alt=""
                    class="look_detail_icon"
                  />
                </div>
                <div class="name_con">
                  <p class="cn">
                    {{ subject.name }}
                    <span v-show="subject.extended_field1 !== ''"
                      >({{ subject.extended_field1 }})</span
                    >
                    <span v-show="getSubjectLanguage(subject) !== ''"
                      >【{{ getSubjectLanguage(subject) }}】</span
                    >
                  </p>
                  <p class="en">{{ subject.name_en }}</p>
                </div>
              </div>
            </div>
            <div
              class="look_detail_icon"
              :style="{ color: getLangColor(subject) }"
              @click="goDetail(subject, 0)"
            >
              <span>查看详情</span>
              {{ getLookText(subject.alias) }}
            </div>
          </div>
          <div class="text_cn">
            {{ subject.describe }}
          </div>
          <!-- <div class="text_en">
            {{ subject.describe_en }}
          </div> -->
          <div class="swiper_con">
            <swiper :options="swiperOption" ref="mySwiper" class="swiper">
              <swiper-slide
                v-for="(v, index) in subject.courseList"
                :key="index"
                style="width: 3.5rem;"
              >
                <div
                  class="video_con"
                  :data-info="v.name"
                  @click="goDetail(subject, index)"
                >
                  <div class="video_cover">
                    <img :src="v.cover_url" class="cover" />
                  </div>
                  <div class="titleBox">
                    <div class="course_title">
                      <div class="cn">{{ v.name }}</div>
                      <div class="en">{{ v.name_en }}</div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div
                class="swiper-button-prev"
                slot="button-prev"
                v-show="subject.courseList && subject.courseList.length > 3"
              ></div>
              <div
                class="swiper-button-next"
                slot="button-next"
                v-show="subject.courseList && subject.courseList.length > 3"
              ></div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="../img/harmonious2025/footer.png" />
      <!-- <div class="copyright">版权所有 © 中央广播电视总台 中文联盟</div> -->
    </div>
  </div>
</template>

<script>
// 方法注释保留，其余注释移除
import frame0 from "../img/harmonious2025/Frame.png";
import frame1 from "../img/harmonious2025/Frame(1).png";
import frame2 from "../img/harmonious2025/Frame(2).png";
import frame3 from "../img/harmonious2025/Frame(3).png";
import frame4 from "../img/harmonious2025/Frame(4).png";
import frame5 from "../img/harmonious2025/Frame(5).png";
import frame6 from "../img/harmonious2025/Frame(6).png";

export default {
  name: "harmoniousVideoExhibition2025",

  components: {},

  metaInfo() {
    return {
      title: "2025和合之美 ,中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content: "2025和合之美,中央广播电视总台,精品节目展播",
        },
        {
          name: "description",
          content: "2025和合之美 中央广播电视总台精品节目展播",
        },
      ],
    };
  },

  data: function() {
    return {
      activeLang: "中文",
      subject_info: [],
      anchorOffset: 50,
      isPcThemeIntroFixed: false,
      pcThemeIntroInitialTop: 0,
      isProgrammaticScrolling: false,
      programmaticTargetTop: 0,
      programmaticTargetLang: "",

      languageList: [
        {
          type: "中文",
          alias: "yangshi2025-cn",
          url: frame0,
          color: "#FA877D",
          look: "VIEW DETAIL",
        },
        {
          type: "English",
          alias: "yangshi2025-en",
          url: frame1,
          color: "#778EDA",
          look: "VIEW DETAIL",
        },
        {
          type: "Русский",
          alias: "yangshi2025-ru",
          url: frame2,
          color: "#AE79B2",
          look: "ПОСМОТРЕТЬ ДЕТАЛИ",
        },
        {
          type: "Казахский",
          alias: "yangshi2025-ka",
          url: frame3,
          color: "#3BB3BE",
          look: "МӘЛІМЕТТЕРДІ ҚАРАУ",
        },
        {
          type: "Español",
          alias: "yangshi2025-sp",
          url: frame4,
          color: "#B79436",
          look: "VER DETALLE",
        },
        {
          type: "Português Brasileiro",
          alias: "yangshi2025-bp",
          url: frame5,
          color: "#86B364",
          look: "VEJA DETALHES",
        },
        {
          type: "Français",
          alias: "yangshi2025-fr",
          url: frame6,
          color: "#4EA3EE",
          look: "Voir les détails",
        },
      ],

      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        speed: 500,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
    };
  },

  mounted() {
    this.getCollectList();
    this.$nextTick(() => {
      this.updateSwipers();
      // 初始化吸顶位置与偏移
      if (this.$refs && this.$refs.pcThemeIntro) {
        const rect = this.$refs.pcThemeIntro.getBoundingClientRect();
        this.pcThemeIntroInitialTop =
          rect.top +
          (window.pageYOffset || document.documentElement.scrollTop || 0);
        const h = this.$refs.pcThemeIntro.offsetHeight || 0;
        if (h > 0) this.anchorOffset = h + 50; // 额外加 10px 缓冲
      }
      window.addEventListener("scroll", this.onPcScroll, false);
      window.addEventListener("resize", this.onPcResize, false);
    });
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onPcScroll);
    window.removeEventListener("resize", this.onPcResize);
  },

  methods: {
    // 统一计算滚动偏移：吸顶栏实时高度 + 固定缓冲，供跳转与联动统一使用
    getScrollOffset() {
      const bar = this.$refs && this.$refs.pcThemeIntro;
      const barH = (bar && bar.offsetHeight) || 0;
      const extra = 50;
      return barH + extra;
    },
    onPcResize() {
      if (this.$refs && this.$refs.pcThemeIntro) {
        const rect = this.$refs.pcThemeIntro.getBoundingClientRect();
        this.pcThemeIntroInitialTop =
          rect.top +
          (window.pageYOffset || document.documentElement.scrollTop || 0);
        this.anchorOffset = this.getScrollOffset();
        this.onPcScroll();
      }
    },
    onPcScroll() {
      const y =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (
        !this.pcThemeIntroInitialTop &&
        this.$refs &&
        this.$refs.pcThemeIntro
      ) {
        const rect = this.$refs.pcThemeIntro.getBoundingClientRect();
        this.pcThemeIntroInitialTop =
          rect.top +
          (window.pageYOffset || document.documentElement.scrollTop || 0);
      }
      this.isPcThemeIntroFixed = y >= this.pcThemeIntroInitialTop;

      // 程序化滚动期间：检测是否到达目标（以不小于目标位置为准）
      if (this.isProgrammaticScrolling) {
        if (y + 1 >= this.programmaticTargetTop) {
          this.isProgrammaticScrolling = false;
          if (this.programmaticTargetLang) {
            this.activeLang = this.programmaticTargetLang;
          }
          return; // 到达目标这一帧不执行 scrollspy，防止被覆盖
        } else {
          return; // 尚未到达，跳过 scrollspy
        }
      }

      // ScrollSpy：根据滚动位置联动选中语言（统一偏移）
      try {
        const sections = document.querySelectorAll(".classBox[data-lang]");
        if (sections && sections.length) {
          const runtimeOffset = this.getScrollOffset();
          const viewportTop = y + runtimeOffset + 1;
          let currentLang = this.activeLang;
          let bestTop = -Infinity;
          sections.forEach((sec) => {
            const attr = sec.getAttribute("data-lang");
            if (!attr) return;
            const r = sec.getBoundingClientRect();
            const absTop =
              r.top +
              (window.pageYOffset || document.documentElement.scrollTop || 0);
            if (absTop <= viewportTop && absTop > bestTop) {
              bestTop = absTop;
              currentLang = attr;
            }
          });
          if (currentLang && currentLang !== this.activeLang) {
            this.activeLang = currentLang;
          }
        }
      } catch (e) {
        // 忽略异常，避免打断滚动
      }
    },
    /**
     * 切换语言并跳转到对应内容区域
     * @param {string} lang - 语言类型
     */
    switchLang(lang) {
      this.activeLang = lang;
      this.scrollToLanguage(lang);
    },

    /**
     * 跳转到指定语言的classBox
     * @param {string} lang - 语言类型
     */
    scrollToLanguage(lang) {
      const targetElement = document.querySelector(
        `.classBox[data-lang="${lang}"]`
      );
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const currentScrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        // 使用统一偏移，避免到达后与联动判定不一致
        const offset = this.getScrollOffset();
        const targetTop = rect.top + currentScrollTop - offset;
        this.isProgrammaticScrolling = true;
        this.programmaticTargetTop = Math.max(targetTop, 0);
        this.programmaticTargetLang = lang;
        window.scrollTo({
          top: this.programmaticTargetTop,
          behavior: "smooth",
        });
      }
    },

    /**
     * 获取系列的语言类型
     * @param {Object} subject - 系列对象
     * @returns {string} 语言名称
     */
    getSubjectLanguage(subject) {
      return this.resolveLanguageName(subject && subject.alias) || "中文";
    },

    /**
     * 获取系列列表数据
     * 从后端API获取所有系列信息
     */
    getCollectList() {
      this.$utils
        .get("/subject/lesson_Collection/getlist", {
          limit: 999,
          alias:
            "yangshi2025-cn,yangshi2025-en,yangshi2025-ru,yangshi2025-ka,yangshi2025-sp,yangshi2025-bp,yangshi2025-fr",
        })
        .then((res) => {
          if (res.data.success) {
            this.subject_info = this.sortByAlias(res.data.data.list || []);
            this.getAllInfo();
          }
        });
    },

    /**
     * 获取所有系列的课程详情
     * 遍历每个系列，获取其包含的课程信息
     */
    getAllInfo() {
      this.subject_info.forEach((item) => {
        this.getSubjectInfo(item);
      });
    },

    /**
     * 获取指定系列的课程详情
     * @param {Object} item - 系列对象
     */
    getSubjectInfo(item) {
      this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: item.id,
          order: "sort",
          limit: 30,
        })
        .then((res) => {
          if (res.data.success) {
            item.courseList = res.data.data.list;
            this.$forceUpdate();
            this.$nextTick(() => {
              this.updateSwipers();
            });
          }
        });
    },

    /**
     * 根据系列数据获取云朵背景图片
     * @param {Object} subject - 系列对象
     * @returns {string} 背景图片URL
     */
    getCloudBackground(subject) {
      const languageField = (
        this.resolveLanguageName(subject && subject.alias) || ""
      ).trim();
      const hasList =
        Array.isArray(this.languageList) && this.languageList.length > 0;
      const firstUrl = hasList ? this.languageList[0].url : "";
      if (!languageField) {
        return firstUrl
          ? `url(${firstUrl})`
          : "url(../img/harmonious2025/Frame.png)";
      }
      if (hasList) {
        const matchedLanguage = this.languageList.find(
          (lang) => lang.type === languageField
        );
        if (matchedLanguage && matchedLanguage.url) {
          return `url(${matchedLanguage.url})`;
        }
        return `url(${firstUrl})`;
      }
      return "url(../img/harmonious2025/Frame.png)";
    },

    /**
     * 根据语言类型返回对应颜色
     * @param {Object} subject - 系列对象（含 extended_field2）
     * @returns {string} 颜色值
     */
    getLangColor(subject) {
      const lang = this.resolveLanguageName(subject && subject.alias) || "";
      const list = this.languageList || [];
      if (!list.length) return "#FA877D";
      if (!lang) return list[0].color;
      const found = list.find((l) => l.type === lang);
      return (found && found.color) || list[0].color;
    },

    /**
     * 将后端传入的 alias 映射为展示用语言名
     * @param {string} alias - 例如：yangshi2025-cn
     * @returns {string} 语言名，如 中文/English 等
     */
    resolveLanguageName(alias) {
      const list = this.languageList || [];
      if (!alias) return "";
      const found = list.find(
        (item) => item.alias === alias || item.type === alias
      );
      return (found && found.type) || "";
    },

    /**
     * 根据 alias 获取对应的 look 文本
     * @param {string} alias - 例如：yangshi2025-cn
     * @returns {string} look 文本
     */
    getLookText(alias) {
      const list = this.languageList || [];
      if (!alias) return "查看详情";
      const found = list.find(
        (item) => item.alias === alias || item.type === alias
      );
      return (found && found.look) || "查看详情";
    },

    // 纯函数：按固定 alias 顺序返回新的已排序数组，避免二次渲染
    sortByAlias(list) {
      const orderedAliases = "yangshi2025-cn,yangshi2025-en,yangshi2025-ru,yangshi2025-ka,yangshi2025-sp,yangshi2025-bp,yangshi2025-fr"
        .split(",")
        .map((s) => s.trim());
      const rank = {};
      orderedAliases.forEach((a, i) => (rank[a] = i));
      return (Array.isArray(list) ? [...list] : []).sort((a, b) => {
        const ra = Object.prototype.hasOwnProperty.call(rank, a && a.alias)
          ? rank[a.alias]
          : Number.MAX_SAFE_INTEGER;
        const rb = Object.prototype.hasOwnProperty.call(rank, b && b.alias)
          ? rank[b.alias]
          : Number.MAX_SAFE_INTEGER;
        return ra - rb;
      });
    },

    /**
     * 跳转到详情页面
     * @param {Object} item - 系列对象
     * @param {number} i - 视频索引
     */
    goDetail(item, i) {
      this.$router.push({
        path: "/pcpage/hm2025_detail",
        query: {
          collection_id: item.id,
          videoIndex: i,
          lang: item.alias,
        },
      });
    },

    /**
     * 更新所有 Swiper 实例，兼容单个或数组引用
     */
    updateSwipers() {
      const refs = this.$refs.mySwiper;
      if (!refs) return;
      if (Array.isArray(refs)) {
        refs.forEach(
          (r) => r && r.swiper && r.swiper.update && r.swiper.update()
        );
      } else if (refs.swiper && refs.swiper.update) {
        refs.swiper.update();
      }
    },

    /**
     * 按固定 alias 顺序重排 subject_info
     */
    reorderSubjects() {
      const orderedAliases = "yangshi2025-cn,yangshi2025-en,yangshi2025-ru,yangshi2025-ka,yangshi2025-sp,yangshi2025-bp,yangshi2025-fr"
        .split(",")
        .map((s) => s.trim());
      const rank = {};
      orderedAliases.forEach((a, i) => (rank[a] = i));
      const list = Array.isArray(this.subject_info) ? this.subject_info : [];
      list.sort((a, b) => {
        const ra = Object.prototype.hasOwnProperty.call(rank, a && a.alias)
          ? rank[a.alias]
          : Number.MAX_SAFE_INTEGER;
        const rb = Object.prototype.hasOwnProperty.call(rank, b && b.alias)
          ? rank[b.alias]
          : Number.MAX_SAFE_INTEGER;
        return ra - rb;
      });
      this.subject_info = list;
    },
  },
};
</script>

<style scoped lang="scss">
.xt {
  font-style: italic;
}
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100vh;
  user-select: none;
  background: #f6fdff;

  .header_banner {
    position: relative;
    width: 100%;
    height: 640px;
    overflow: hidden;

    .banner_img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center;
    }

    .infoCon {
      .centerBg {
        width: 1200px;
        margin: auto;
        position: absolute;
        top: 20px;
        left: 90px;
        right: 0;

        .left {
          float: left;
          margin-top: 20px;
        }

        .right {
          float: right;
        }
      }
    }
  }

  .theme_intro {
    margin: 0 auto;
    width: 1200px;
    height: 420px;
    margin-top: -150px;
    background: #ffffff;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 10px 10px;
    position: relative;
    overflow: hidden;
    .theme_intro_cn {
      width: 1100px;
      height: 120px;
      margin-left: 49px;
      margin-top: 35px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      text-indent: 2em;
    }
    .theme_intro_en {
      width: 1100px;
      height: 120px;
      margin-left: 49px;
      margin-top: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .theme_intro_footer {
      position: absolute;
      bottom: 0;
      width: 1200px;
      height: 60px;
      display: flex;
      border-radius: 10px;
      overflow: hidden;
      &.is-fixed {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 1200px;
        z-index: 2000;
        background: #fff3d2;
        border-radius: 10px;
        overflow: hidden;
      }
      .theme_intro_footer_left {
        width: 200px;
        height: 60px;
        background: #ffd667;
        .theme_intro_footer_title {
          // width: 151px;
          height: 39px;
          margin-right: 24px;
          margin-top: 11px;
          .theme_intro_footer_title_top {
            text-align: right;
            font-family: Inter, Inter;
            font-weight: 400;
            font-size: 20px;
            color: #000000;
            margin-bottom: 5px;
          }
          .theme_intro_footer_title_bottom {
            width: 100%;
            text-align: right;
            font-family: Inter, Inter;
            font-weight: 400;
            font-size: 12px;
            color: #000000;
          }
        }
      }
      .theme_intro_footer_right {
        position: absolute;
        bottom: 0;
        left: 200px;
        width: 960px;
        height: 60px;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        background: #fff3d2;
        padding: 0 20px;

        .lang_tab {
          padding: 0 12px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #000000;
          cursor: pointer;
          position: relative;
          transition: all 0.3s;
          height: 100%;
          display: flex;
          align-items: center;

          &:hover {
            color: #c0392b;
          }

          &.active {
            color: #c0392b;

            &::after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 3px;
              background: #c0392b;
              border-radius: 2px;
            }
          }
        }
      }
    }
  }

  .core_content {
    margin: 0 auto;
    width: 1200px;
    padding: 20px 0;
    margin-bottom: 200px;
  }

  .footer {
    position: absolute;
    bottom: -110px;
    left: 0;
    right: 0;
    z-index: 1;

    img {
      width: 100%;
      height: auto;
      display: block;
    }

    .copyright {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 12px;
      color: #38475d;
      text-align: center;
    }
  }

  .classBox {
    margin-top: 42px;
    margin-bottom: 70px;

    .series_info {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info_left {
        display: flex;
        .cloud_con {
          width: 209px;
          height: 50px;
          background-repeat: no-repeat;
          background-position: center bottom;
          position: relative;
          float: left;

          .serise_icon_con {
            position: absolute;
            left: 19px;
            bottom: 29px;
            border: solid 2px #ffffff;

            img {
              border-radius: 4px;
              width: 60px;
              height: 60px;
              display: block;
            }
          }
          .name_con {
            position: absolute;
            left: 89px;
            bottom: 28px;
            width: 700px;
            text-align: left;

            .cn {
              font-family: SourceHanSansCN;
              font-weight: bold;
              font-size: 30px;
              color: #364347;
              margin-bottom: 4px;
              line-height: 1.2;

              span:first-child {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-size: 24px;
                color: #38475d;
                font-weight: normal;
                margin-left: 8px;
              }

              span:last-child {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-size: 24px;
                color: #38475d;
                font-weight: normal;
                margin-left: 8px;
              }
            }

            .en {
              font-family: SourceHanSansCN;
              font-weight: bold;
              font-size: 16px;
              color: #93a4aa;
              line-height: 1.2;
            }
          }
        }
      }

      .look_detail_icon {
        cursor: pointer;
        width: 341px;
        height: 18px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        line-height: 18px;
        // color: #ae79b2;
        font-style: normal;
        text-transform: none;
        text-align: right;
        span {
          margin-right: 5px;
        }
      }
    }

    .text_cn {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #7c869e;
      text-align: justify;
      line-height: 24px;
      margin-top: 20px;
      margin-bottom: 5px;
      text-indent: 2em;
    }

    .text_en {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #7c869e;
      text-align: justify;
      line-height: 20px;
      // text-indent: 2em;
    }

    .swiper_con {
      margin-top: 25px;
      margin-left: 0rem;
      position: relative;

      .swiper-container {
        position: unset;
      }

      .swiper {
        .swiper-slide {
          width: 3.6rem !important;

          .swiperBox {
            overflow: hidden;
          }
        }

        .video_con {
          width: 3.6rem;

          .video_cover {
            width: 3.6rem;
            height: calc(3.4rem / (16 / 9));
            background-color: #f6453f;

            img {
              display: block;
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }

          .titleBox {
            position: absolute;
            height: 55px;
            margin-top: -55px;
            width: 100%;
            color: #fff;
            background-color: #55565775;
            text-align: left;
            z-index: 100;
            display: flex;
            align-items: center;

            .course_title {
              padding: 10px 20px;

              .cn {
                font-size: 16px;
              }

              .en {
                margin-top: 4px;
                font-size: 14px;
              }
            }
          }
        }
      }

      .swiper-button-prev {
        background-image: url(../img/chineseCultureVideoExhibition2025/prev.png);
        position: absolute;
        left: -75px;
        top: 90px;
        width: 44px;
        height: 44px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        z-index: 10;
      }

      .swiper-button-next {
        background-image: url(../img/chineseCultureVideoExhibition2025/next.png);
        right: -75px;
        top: 90px;
        width: 44px;
        height: 44px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        z-index: 10;
      }
    }
  }
}
</style>
